export default "__VITE_ASSET__Dj2FCj1D__"